module.exports = __webpack_public_path__ + "img/odr-radio.04a68db2.png";